export const auctionsStates = {
  1: { label: 'Creada', color: 'success', icon: 'SearchIcon' },
  2: { label: 'En Preparación', color: 'secondary', icon: 'EyeIcon' },
  3: { label: 'Planificada', color: 'warning', icon: 'SearchIcon' },
  4: { label: 'Publicada', color: 'success', icon: 'SendIcon' },
  5: { label: 'Cancelada', color: 'danger', icon: 'SearchIcon' },
  6: { label: 'Finalizada', color: 'dark', icon: 'SearchIcon' },
};
export const auctionsStateCode = {
  creada: 1,
  preparacion: 2,
  planificada: 3,
  publicada: 4,
  cancelada: 5,
  finalizada: 6
};
export const auctionsActionStates = {
  DESPREPARAR: 'des-preparar',
  PLANIFICAR: 'planificar',
  PUBLICAR: 'publicar',
  PREPARAR: 'preparar',
  FINALIZAR: 'finalizar',
  CANCELAR: 'cancelar'
};
export const CANCEL_STATES = [
  auctionsStateCode.publicada
];
export const PREPARE_STATES = [
  auctionsStateCode.creada
];
export const UN_PREPARE_STATES = [
  auctionsStateCode.preparacion
];
export const PUBLISH_STATES = [
  auctionsStateCode.planificada
];
export const END_STATES = [
  auctionsStateCode.publicada
];
